import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MapLayersIcon from '@/images/map-layers.svg?react';
import GlobeIcon from '@/images/globe.svg?react';
import UsersGroupIcon from '@/images/users-group.svg?react';
import XIcon from '@/images/x.svg?react';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const navigation = [
    {
      name: t('navigation.spatialData'),
      href: '/spatial-data',
      icon: <MapLayersIcon className="w-5 h-5" />,
    },
    {
      name: t('navigation.visualization'),
      href: '/visualization',
      icon: <GlobeIcon className="w-5 h-5" />,
    },
    {
      name: t('navigation.users'),
      href: '/users',
      icon: <UsersGroupIcon className="w-5 h-5" />,
    },
  ];

  return (
    <>
      {/* Desktop Sidebar Navigation - Only navigation items */}
      {!isOpen && (
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  isActive
                    ? 'bg-blue-100 text-blue-700 border-r-4 border-blue-700'
                    : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'
                }`
              }
            >
              <span className="mr-3 flex-shrink-0">{item.icon}</span>
              {item.name}
            </NavLink>
          ))}
        </nav>
      )}

      {/* Mobile Sidebar - Only render when open */}
      {isOpen && (
        <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 shadow-sm">
          <div className="flex items-center justify-between flex-shrink-0 h-16 px-6 border-b border-gray-200">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center">
                <span className="text-white text-sm font-bold">LA</span>
              </div>
              <div className="ml-3">
                <h1 className="text-lg font-semibold text-gray-900">
                  Building Admin 3D
                </h1>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          <nav className="px-3 py-4 space-y-1">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={onClose}
                className={({ isActive }) =>
                  `group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                    isActive
                      ? 'bg-blue-100 text-blue-700 border-r-4 border-blue-700'
                      : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'
                  }`
                }
              >
                <span className="mr-3 flex-shrink-0">{item.icon}</span>
                {item.name}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};

export default Sidebar;
